import { IS_FROM_SAILTHRU } from 'base/lib/login_helper'
import isEmpty from 'lodash/isEmpty'
import omit from 'lodash/omit'

function user(state = null, action) {
  switch (action.type) {
    case 'RESET_USER':
      return action.payload

    case 'RECEIVE_INITIAL_SESSION': {
      if (!action.payload.user) return state

      const userWithoutAddresses = omit(action.payload.user, 'addresses')
      return { ...state, ...userWithoutAddresses }
    }

    default:
      return state
  }
}

export function getIsAdminUser(state) {
  if (isEmpty(state)) {
    return false
  }

  const roles = [...state.roles, ...state.active_retail_roles]

  for (const role of [
    'cx',
    'creative',
    'logistics',
    'merch',
    'super_user',
    'retail',
    'international',
  ]) {
    if (roles.includes(role)) {
      return true
    }
  }

  return false
}

export function getIsRegistrationCompleted(state) {
  return state.has_password || state.facebook_connected || state.google_connected
}

export function canShowStaticLoginGate(state) {
  return !state.session.user && !state.session.visitor.dismissedLoginGate && !IS_FROM_SAILTHRU()
}

export default user
